// Create a single QueryClient instance or import your existing one

import { queryClient } from 'index';

/**
 * Invalidates one or multiple queries by their key(s),
 * causing them to refetch on next render/use.
 *
 * @param queryKey - A single query key or an array of query keys to invalidate
 */
export const invalidateQueries = (queryKey: string | string[]) => {
  if (Array.isArray(queryKey)) {
    queryKey.forEach((key) =>
      queryClient.invalidateQueries({ queryKey: [key] })
    );
  } else {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  }
};
